module.exports = __webpack_public_path__ + "static/white-logo-2363880a9829dcd703d03982f3b76294.png";